<template>
    <div id="mail">
        <div class="banner">
            <div class="hd">
                <div class="h pubw">
                    <span>即時比較國際快遞，彈指間便能選擇
                        最抵丶最快捷的物流路線</span>
                </div>
                <div class="submenu pubw">
                    <div class="sub" v-for="item in submenu" :key="item.id" @click="handleMailTypeClick(item.id)">
                        <div class="img">
                            <img :src="require(`${item.img}`)" alt="箱子">
                        </div>
                        <div class="title">{{item.title}}</div>
                        <div class="slecked">
                            <div class="Myselection" v-model="curType" :label="item.id">
                                <span v-show="curType==item.id" class="selection-border"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd">
                <div class="pubw">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <div class="weight">
            <Weight :getMaxWeight="getMaxWeight"/>
        </div>
        <div class="budget">
            <Budget :maxWeight="maxWeight"/>
        </div>
    </div>
</template>

<script>
    // 引入组件
import Weight from "@/components/Weight.vue"
import Budget from "@/views/Mail/Budget/Budget.vue"
export default {
    name:'Mail',
    components:{
        Weight,
        Budget
    },
    data(){
        return {
            //   寄件菜单
            submenu:[
                {
                    id:1,
                    title:'寄信封',
                    img:"./img/letter.png"
                },
                {
                    id:2,
                    title:'寄小郵包',
                    img:"./img/pack.png"
                },
                {
                    id:3,
                    title:'寄箱子',
                    img:"./img/box.png"
                },
                {
                    id:4,
                    title:'寄板車',
                    img:"./img/car.png"
                }
            ],
            // 当前的选择的物品类型
            curType:'1',
            // 当前最大重量
            maxWeight:0,
        }
    },  
    created() {
        this.$router.push("/mail/type1")
    },
    methods: {
        // 监听点击寄件类型
        async handleMailTypeClick(type){
            if(type == this.curType)return;
            if(type == '4'){
                        const confirmResult = await this.$confirm('因國內外航機班次及價格變動非常迅速，暫時只能通過電郵報價。聯繫我們: Hello@goods2go.io', '提示',
                    {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).catch(err => err)

                return
            }
            if(type == "1" || this.curType == "1"){
                const confirmResult = await this.$confirm('信件不能和物品混合，此操作將過濾之前選擇的箱子，是否繼續？', '提示',
                    {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).catch(err => err)
                if(confirmResult !== 'confirm'){
                    return this.$message.info('已取消')
                }
            }
            this.$store.commit("CHANGEBOXTYPE",'0'+type)
            this.curType = type
            this.$router.push(`/mail/type${type}`)
        },
        // 获取最大重量
        getMaxWeight(value){
            this.maxWeight = value
        }
    },

}
</script>

<style scoped lang="less">
    #mail{
        background-color: #F2F2F2;
        .banner{
            .hd{
                height: 500px;
                padding-top:100px;
                .h{
                    font-size: 35px;
                    font-family: PingFang HK;
                    margin: 0 auto;
                    text-align:left;
                    span{
                        display: inline-block;
                        line-height:50px;
                        width: 600px;
                    }
                }
                .submenu{
                    display: flex;
                    justify-content: space-around;
                    margin-top: 70px;
                    height: 200px;
                    align-items: baseline;
                    .sub{
                        text-align: center;
                        width: 200px;
                        height: 200px;
                        .title{
                            font-size: 18px;
                            margin: 15px 0;
                        }
                        .slecked{
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .el-radio__label{
                                display: none;
                            }
                        }
                        &:hover{
                            cursor: pointer;
                        }
                    }
                }
            }
            .bd{
                background-color: #fff;
            }
        }
    }

  /* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>
